document.addEventListener('click', (event) => {
    const generalCheckoutSelector = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [class*="checkout"], .cart-checkout-button';
    const clickedCheckoutElement = event.target.closest(generalCheckoutSelector);

    if (clickedCheckoutElement && window.hulkapps !== undefined && typeof is_draft_order !== 'undefined' && is_draft_order) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        hulkappsCheckout();
    }
}, true);